import Serializer from 'umg-ember-backend/serializers/application';

export default class CalendarEventSerializer extends Serializer {
  attrs = {
    ownedByChannel: 'ownedByChannelId',
  };
}
